module.exports = __webpack_public_path__ + "static/img/daniel.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/daniel.jpg
// module id = Gp81
// module chunks = 0